import { useLoginStore } from '@/login/stores/useLoginStore';
import { ResErr, ResgateManager } from '@/newApi/services/ResgateManager';
import type { InvolveEmployeeSearchParams, InvolveEmployeeSearchResult } from '@sysarb/sysarb-types-v2/services/v1/base-registry';
import type { QueryOptions } from '@tanstack/vue-query';
import { toValue, type MaybeRefOrGetter } from 'vue';

const service = 'base-registry-service';

type InvolveReportEmployeeSearchOptions = {
    queries: {
        searchEmployees: (params: MaybeRefOrGetter<InvolveEmployeeSearchParams>, enabled?: MaybeRefOrGetter<boolean>) => () => QueryOptions<InvolveEmployeeSearchResult | null>,
    },
};

export const involveReportEmployeeSearch: InvolveReportEmployeeSearchOptions = {
    queries: {
        searchEmployees: (params: MaybeRefOrGetter<InvolveEmployeeSearchParams>, enabled: MaybeRefOrGetter<boolean> = false): () => QueryOptions<InvolveEmployeeSearchResult | null> => {
            const { instanceTopic } = useLoginStore();
            const topic = `v1.${instanceTopic}.involve-report-employee-search`;
            const method = 'search';
            return () => ({
                queryKey: [service, topic, method, toValue(params)] as const,
                queryFn: async (): Promise<InvolveEmployeeSearchResult | null> => {
                    const resgate = ResgateManager.getInstance();
                    return resgate.call<InvolveEmployeeSearchResult | null>(topic, method, toValue(params)).then(res => {
                        if (res instanceof ResErr) {
                            throw new Error(res.message);
                        }
                        return res;
                    });
                },
                enabled: () => toValue(enabled),
            });
        }
    }
};
